import {useDispatch, useSelector} from 'react-redux';
import {
    ctxClinicalConclusionNeeded,
    openPatientForm,
    setClinicalConclusionNeeded,
} from '../../../../store/reducers/patientContext';
import AgyleDialog from '../../../../components/modal/agyleDialog';
import AgyleButton from '../../../../components/ui/buttons/agyleButton';
import InformationBox from '../../../../components/other/informationBox';
import React, {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import useOpenState from '../../../../hooks/useOpenState';

const PatientContextClinicalConclusionNeeded = ({onClose}) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const ccNeeded = useSelector(ctxClinicalConclusionNeeded);

    const [isClinicalConclusionMandatoryOpen, openClinicalConclusionMandatory, closeClinicalConclusionMandatory] = useOpenState(false, true);

    useEffect(() => {
        if (ccNeeded?.open) openClinicalConclusionMandatory();
    }, [ccNeeded]);

    const handleCloseClinicalConclusionMandatory = () => {
        dispatch(setClinicalConclusionNeeded({
            open: false,
            fromDischarge: false,
        }));
        closeClinicalConclusionMandatory();
    };

    const handleOpenCC = () => {
        dispatch(openPatientForm('clinicalConclusion'));
        handleCloseClinicalConclusionMandatory();
    };

    const handleClose = () => {
        dispatch(setClinicalConclusionNeeded({
            open: false,
            fromDischarge: false,
        }));
        onClose(true);
    };

    return (
        <AgyleDialog
            title={t('Warning')}
            open={isClinicalConclusionMandatoryOpen}
            onClose={handleCloseClinicalConclusionMandatory}
            width="sm"
            onSave={handleClose}
            submitText={t('Acknowledged')}
            disableSave={ccNeeded?.fromDischarge}
            fullWidth
            buttons={[
                <AgyleButton
                    key="open"
                    onClick={handleOpenCC}
                >
                    {t('Open form')}
                </AgyleButton>,
            ]}
        >
            <InformationBox type="warning">
                {t('Clinical Conclusion form is required.')}
            </InformationBox>
        </AgyleDialog>
    );
};

export default PatientContextClinicalConclusionNeeded;